import React from 'react'
import "./Footer.css"

const Footer = () => {
  return (
    <div className='footer-container'>Footer</div>
  )
}

export default Footer